import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { playerDisplayName } from '../game/presentation';
import { humanizeFirebaseError } from '../hooks/useGame';
import { createGameDocument } from '../services/gameRepository';

const StartGame: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [playerName, setPlayerName] = useState(playerDisplayName(currentUser));
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCreate = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!currentUser) {
      navigate('/login');
      return;
    }
    const name = playerName.trim();
    if (!name) {
      setError('Enter a name so friends know who you are.');
      return;
    }

    try {
      setLoading(true);
      setError('');
      const gameId = await createGameDocument(currentUser.uid, name);
      navigate(`/game-lobby/${gameId}`);
    } catch (err) {
      setError(humanizeFirebaseError(err));
      setLoading(false);
    }
  };

  return (
    <div className="ss-sheet">
      <p className="ss-kicker">Host</p>
      <h1 className="ss-title">Create a game</h1>
      <p className="ss-sub">You’ll get a short code to share. Friends sign in and join.</p>

      {error && <div className="ss-error">{error}</div>}

      <form onSubmit={handleCreate}>
        <label htmlFor="hostName" className="ss-label">
          Your name
        </label>
        <input
          id="hostName"
          className="ss-input"
          value={playerName}
          onChange={(event) => setPlayerName(event.target.value)}
          placeholder="Pat"
          autoComplete="nickname"
          required
        />
        <div className="ss-row">
          <button type="button" className="ss-btn ss-btn-ghost" onClick={() => navigate('/')}>
            Back
          </button>
          <button type="submit" className="ss-btn ss-btn-primary" disabled={loading}>
            {loading ? 'Creating…' : 'Create'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default StartGame;
